import { useState } from 'react';
import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: standard convex _generated import
import type { TDashboardTimeRange, TRenewalTimeRange } from '@/@types/aiReply';

const TIME_RANGE_MS: Record<TDashboardTimeRange, number> = {
  '24h': 24 * 60 * 60 * 1000,
  '7d': 7 * 24 * 60 * 60 * 1000,
  '30d': 30 * 24 * 60 * 60 * 1000,
};

const RENEWAL_DAYS: Record<TRenewalTimeRange, number> = {
  '30d': 30,
  '60d': 60,
  '90d': 90,
};

export function useDashboardStats() {
  const [statsTimeRange, setStatsTimeRange] = useState<TDashboardTimeRange>('7d');
  const [renewalTimeRange, setRenewalTimeRange] = useState<TRenewalTimeRange>('30d');

  const stats = useQuery(api.aiReply.dashboard.getMessageStats, {
    timeRangeMs: TIME_RANGE_MS[statsTimeRange],
  });

  const renewalPolicies = useQuery(api.aiReply.dashboard.getRenewalPolicies, {
    daysAhead: RENEWAL_DAYS[renewalTimeRange],
  });

  return {
    stats,
    statsTimeRange,
    setStatsTimeRange,
    renewalPolicies,
    renewalTimeRange,
    setRenewalTimeRange,
    isStatsLoading: stats === undefined,
    isRenewalLoading: renewalPolicies === undefined,
  };
}
